module.exports = __webpack_public_path__ + "img/angle-down.8820fe00.svg";